import request from '@/utils/request'
// 客户跟进列表
export function adminFollowListGet(params) {
  return request({
    url: '/admin/follow/list',
    method: 'get',
    params: params
  })
}
// 查询用户跟进信息
export function clientFollowDetailGet(params) {
  return request({
    url: '/admin/follow/detail',
    method: 'get',
    params: params
  })
}

// 查询跟进记录
export function adminFollowrecordList(params) {
  return request({
    url: '/admin/follow/record',
    method: 'get',
    params: params
  })
}
// 跟进安排客户信息
export function adminFollowInfoGet(params) {
  return request({
    url: '/admin/follow/info',
    method: 'get',
    params: params
  })
}

// 跟进安排
export function clientAddFollow(data) {
  return request({
    url: '/admin/follow/addFollow',
    method: 'post',
    data: data
  })
}

// 提交跟进记录
export function addFollowRecord(data) {
  return request({
    url: '/admin/follow/commitRecord',
    method: 'post',
    data: data
  })
}

// 批量指定
export function quantityFollowSwitchWorker(data) {
  return request({
    url: '/admin/follow/switchWorker',
    method: 'PUT',
    data: data
  })
}

// 口令
export function adminFollowWorkerInfo(params) {
  return request({
    url: '/admin/follow/worker/info',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/PotentialCustomers.js